// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__b03sW"};